<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap>
        <v-flex xs12 class="tableKDF smallerexpansion pt-2">
          <v-expansion-panel v-model="panel" expand>
            <v-expansion-panel-content flat expand>
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{BBLABEL}}</div>
              </template>
              <v-layout row justify-start wrap>
                <v-flex xs10>
                  <v-card class="text-xs-left" flat color="">
                    <v-card-title class="body-2 font-weight-normal pb-2">
                      <span v-html="infoTitle" v-if="infoTitle"></span>
                    </v-card-title>
                    <v-layout row justify-center wrap>
                      <img v-if="graphImage !== null" :src='graphImage' alt="" width="100%" style="max-width: 1024px;"/>
                    </v-layout>
                    <v-card-text class="pt-0 font-weight-bold">
                      <span style="font-weight: lighter;" v-if="infoRoot">{{infoRoot}}</span>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-card flat>
                  <v-card-text class="pl-5 pt-0">
                    <span v-html="infoText"></span>
                  </v-card-text>
                </v-card>
              </v-layout>
            </v-expansion-panel-content>
            <v-expansion-panel-content expand>
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{'TITLE_DEV_BALANCE_SHEET' | translate}}</div>
              </template>
              <v-layout row wrap justify-start>
                <v-flex xs10 :md6="myData && (myData.ratingNr !== '13')" class="pa-2">
                  <v-card class="text-xs-left" flat color="">
                    <v-layout row>
                      <span v-html="dymOptions.title"></span>
                    </v-layout>
                    <v-layout row justify-center wrap>
                      <LineChart ref="myChart2" :chartData="dymData" :options="dymOptions"></LineChart>
                    </v-layout>
                    <v-card-text>
                      <StrukturBilanzTable :sortDisabled="true" :maxHeight="160" :heightSub="tableHeightSub"
                                           ref="ratingTable"
                                           v-if="false"
                                           configSuffix="BR" tableName="ratingTable"
                                           edoClassName="kz"></StrukturBilanzTable>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm12 md6 class="pa-2" v-if="myData && (myData.ratingNr !== '13')">
                  <v-card flat>
                    <v-layout justify-space-around>
                      <LineChart ref="ratingTableChart" :chartData="ratingTableData" :options="dymOptionsPD"></LineChart>
                    </v-layout>
                    <v-card-text>
                      <StrukturBilanzTable configSuffix="BR" :sortDisabled="true" :maxHeight="160"
                                           :heightSub="tableHeightSub" ref="pdTable" tableName="pdTable"
                                           v-if="false"
                                           edoClassName="kz"></StrukturBilanzTable>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
            <v-expansion-panel-content expand v-if="false">
              <template v-slot:header>
                <span class="underline"></span>
                <div>{{'TITLE_KEY_DATA_BALANCE' | translate}}</div>
              </template>
              <v-card class="pa-5">
                <v-card-text>
                  <StrukturBilanzTable configSuffix="BR" :hasAmpel="true" :sortDisabled="true" :maxHeight="360"
                                       :heightSub="tableHeightSub"
                                       ref="kennzahlenTable"
                                       :hideCategories="true"
                                       :hideHintStars="true"
                                       tableName="kennzahlenTable"
                                       edoClassName="kz"></StrukturBilanzTable>

                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <v-flex xs12 id="tgrad">
          <StrukturBilanzTable configSuffix="RT" :sortDisabled="true" :heightSub="tableHeightSub" ref="ratingTable2"
                               :hasAmpel="true" tableName="ratingTable2" :fixedHeight='fixedHeight' :maxHeight='fixedHeight' :widthSub="40" edoClassName="kz"></StrukturBilanzTable>
        </v-flex>
    </v-layout>
</template>
<script>
  import Vue from 'vue'
  import StrukturBilanzTable from './StrukturBilanzTable'
  import LineChart from './../../widgets/charts/LineChart'
  import BarChart from './../../widgets/charts/BarChart'
  import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'
  import VueMarkdown from 'vue-markdown'

  export default {
    name: 'TabBilanzrating',
    components: {StrukturBilanzTable, LineChart, BarChart, BtnDownloadExcel, VueMarkdown},
    props: ['balance'],
    methods: {
      open: function () {
        Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
        this.reload()
        this.panel = [true, true]
      },
      getMyStyle: function (grad, offset) {
        if (!offset) offset = 0
        var w = $('#tgrad').width() - 2 * 48
        // var css = 'left:' + ((((w / 20) * grad.rating) + offset) )+ 'px'
        var css = 'left:-14px; top:-9px'

        css += ';background-color:transparent;'
        return css
      },
      getMyStyleA: function (grad, offset) {
        console.log('getMyStyleA', grad, offset)
        if (!offset) offset = 0
        var w = 100
        var css = 'left:' + ((((w / 20) * grad.rating))) + '%'
        css += ';background-color:transparent;'
        return css
      },
      close: function () {
        // this.$refs['tabBilanzrating'].close()
      },
      formatPD: function (v) {
        if (!v) return ''
        var maximumFractionDigits = 2
        var minimumFractionDigits = 2
        return (v).toLocaleString('de-DE', {
          style: 'decimal',
          useGrouping: true,
          maximumFractionDigits: maximumFractionDigits,
          minimumFractionDigits: minimumFractionDigits
        })
      },
      onChangeTab: function (tab) {
        console.log('onChangeTab', tab)
      },
      chartDataOf: function (waimeaTable, multi, isPD) {
        var max = -1
        var min = 99999999999
        var l = []
        for (var i in waimeaTable.columns) {
          var col = waimeaTable.columns[i]
          if (col.type === 'year') {
            l.push(col.title)
          }
        }
        var cmp = this
        var datasets = []
        var colors = ['red', 'green', 'black']
        for (var i in waimeaTable.rows) {
          var row = waimeaTable.rows[i]
          var label = '' + i
          var d = []
          for (var c in row.cells) {
            var cell = row.cells[c]
            var col = waimeaTable.columns[c]
            if (col.type === 'year') {
              var t = cell.co
              if (cmp.myData.ratingNr === '13') {
                if (t) {
                  t = ('' + t).replace('CR', '')
                }
              }
              if (t) {
                t = ('' + t).replace(',', '.')
              }
              if (!t || t.length === 0) t = 0
              Vue.prototype.$api.debug('v', multi, t)
              var v = (t * 1) * multi
              Vue.prototype.$api.debug('v', multi, v)
              max = Math.max(max, v)
              min = Math.min(min, v)
              d.push(v)
            } else {
              label = cell.co
            }
          }
          var ds = {
            label: label,
            backgroundColor: colors[i], // '#39d2f8'
            fill: false,
            data: d
          }
          datasets.push(ds)

          if (isPD) {
            this.dymOptionsPD.scales.yAxes[0].ticks.max = Math.ceil(max * 1.1)
            this.dymOptionsPD.scales.yAxes[0].ticks.min = min * 0.9
            this.dymOptionsPD.scales.yAxes[0].ticks.stepSize = (this.dymOptionsPD.scales.yAxes[0].ticks.max - this.dymOptionsPD.scales.yAxes[0].ticks.min) * 0.1
          }
        }
        var chartData = {
          labels: l,
          datasets: datasets
        }
        Vue.prototype.$api.debug('set', chartData)
        return chartData
      },

      onGetData: function (data) {
        console.log('data', data)
        this.myData = data
        data['tables'] = {
          pdTable: data.pdTable,
          kennzahlenTable: data.kennzahlenTable,
          ratingTable: data.ratingTable,
          ratingTable2: data.ratingTable,
          currentSolvency: data.currentSolvency
        }

        this.BBLABEL = data.currentSolvency.title

        this.graphImage = Vue.prototype.storage.host() + '/ajaxGetBankData.php?file=' + data.currentSolvency.chartFile + '&time=' + new Date().getTime()
        this.infoTitle = data.currentSolvency.upperText
        this.infoRoot = data.currentSolvency.lowerText

        /*
        this.infoText = data.score.infoText
        this.infoTitle = data.score.infoTitle
        this.infoRoot = data.score.infoRoot
        */
        if (data.ratingNr === '13') {
          this.capLeft = 'CR 1'
          this.capMiddle = 'CR ' + data.solvencyHistory.rating[0]
          this.capRight = 'CR 20'
        } else {
          let index = (data.gradient.rating) - 1
          this.capLeft = data.ratingScale[0]
          this.capMiddle = data.ratingScale[index]
          this.capRight = data.ratingScale[data.ratingScale.length - 1]
        }

        this.myData.gradient = {
          pd: 1.8635201093208,
          rating: 9,
          title: "Aktuelle Bilanzbonität"
        }
        this.myData.gradient = {
          pd: data.solvencyHistory.pd1[0],
          rating: data.solvencyHistory.rating[0],
          title: data.solvencyHistory.title,
          history: data.solvencyHistory.pd1,
        }

        this.dymData.labels = data.solvencyHistory.years

        this.dymData.datasets[0].data = data.solvencyHistory.rating
        this.dymOptions.scales.yAxes[0].ticks.min = 1
        this.dymOptions.scales.yAxes[0].ticks.max = 19
        this.ratingTableData.labels = data.solvencyHistory.years
        this.ratingTableData.datasets[0].data = data.solvencyHistory.pd1

        let max = -1
        let min = 99999990
        for (let i=0; i < this.ratingTableData.datasets[0].data.length; i++) {
          let v = this.ratingTableData.datasets[0].data[i]
          max = Math.max(max, v)
          min = Math.min(min, v)
        }
        this.dymOptionsPD.scales.yAxes[0].ticks.max = Math.ceil(max * 1.1)
        this.dymOptionsPD.scales.yAxes[0].ticks.min = min * 0.9
        this.dymOptionsPD.scales.yAxes[0].ticks.stepSize = (this.dymOptionsPD.scales.yAxes[0].ticks.max - this.dymOptionsPD.scales.yAxes[0].ticks.min) * 0.1
        this.dymOptions.title = data.solvencyHistory.upperText

        // this.$refs.myChart2.updateRendering()
        this.tableData = data
        Vue.prototype.$api.hideIdle()
        this.fixedHeight = $('#pgMainDI').height()
        console.log('table height', this.fixedHeight)

        let cmp = this
        this.$nextTick(function () {
          if (cmp.$refs.myChart2) {
            console.log('updateRendering')
            cmp.$refs.myChart2.updateRendering()
          }

          if (cmp.$refs['pdTable'] && cmp.$refs['pdTable'].open) {
            cmp.$refs['pdTable'].open(data)
          }
          if (cmp.$refs['kennzahlenTable'] && cmp.$refs['kennzahlenTable'].open) {
            cmp.$refs['kennzahlenTable'].open(data)
          }
          if (cmp.$refs['ratingTable'] && cmp.$refs['ratingTable'].open) {
            cmp.$refs['ratingTable'].open(data)
          }
          if (cmp.$refs['ratingTable2'] && cmp.$refs['ratingTable2'].open) {
            cmp.$refs['ratingTable2'].open(data)
          }
          cmp.showMarker = true
        })
      },
      reCreateAX: function () {
        console.log('reCreateAX')
        Vue.prototype.$api.getAXSemantics(this.balance, true, this.onGetAXData)
      },
      reload: function () {
        Vue.prototype.$api.showIdle()
        let cmp = this
        this.dymOptions.tooltips.callbacks = {
          label: function (tooltipItems, data) {
            let pd = cmp.formatPD(cmp.myData.gradient.history[tooltipItems.index])
            var val = 'CR' + (tooltipItems.yLabel) + ' (' + Vue.i18n.translate('CHART_LABEL_PD') + ' ' + pd +  '%)'
            return val
          }
        }
        this.dymOptions.scales = {
          yAxes: [{
            type: 'linear',
            position: 'left',
            reverse: true,
            ticks: {
              stepSize: 2,
              reverse: true,
              callback: cmp.yScaleFunc
            }
          }]
        }
        if (this.isMock) {
          this.onGetData(this.mockData)
        } else {
          Vue.prototype.$api.getBlianzRatingDataWithBalance(this.balance, this.onGetData)
          // Vue.prototype.$api.getBlianzRatingGraphWithBalance(this.balance, this.onGetGraph)
        }
      },
      yScaleFunc: function (value, index, values) {
        console.log('yScaleFunc', value, index, values)
        // this.myData.ratingScale[(index * 2) - 1]
        return 'CR' + (value)
      },
      onGetAXData: function (axData) {
        this.axData = axData
      },
      onGetGraph: function (gData) {
        // let blob = new Blob([gData], {type: 'image/png'})
        console.log('gData', gData)
        this.graphImage = URL.createObjectURL(gData.data)
        console.log('gData', gData, this.graphImage)
      }
    },
    data() {
      return {
        axData: '',
        infoTitle: '',
        BBLABEL: '()',
        capLeft: '',
        capMiddle: '',
        capRight: '',
        infoText: '',
        infoRoot: '',
        graphImage: null,
        myData: null,
        isMock: false,
        mockData: {},
        panel: null,
        configExcel: {
          excelSheetStammdaten: 0,
          excelSheetStrukturbilanz: 0,
          excelSheetRohbilanz: 0,
          excelSheetKennzahlen: 0,
          excelSheetBilanzrating: 1,
          excelSheetKDF: 0,
          btnName: Vue.i18n.translate('DOWNLOAD_NAME_BR'),
          configName: '',
          type: 'EXCEL-STRUCT'
        },
        tableData: null,
        tabs: 'tabAktiva',
        tab1: 'Rating',
        tab2: 'Kommentar',
        ratingTableData: {
          labels: ['2014', '2015', '2016', '2017'],
          datasets: [
            {
              label: Vue.i18n.translate('CHART_LABEL_BONIT'),
              backgroundColor: '#39d2f8',
              fill: false,
              data: [0, 0, 0, 0]
            }
          ]
        },
        dymData: {
          labels: ['2014', '2015', '2016', '2017'],
          datasets: [
            {
              label: Vue.i18n.translate('CHART_LABEL_BONIT'),
              backgroundColor: '#39d2f8',
              fill: false,
              data: [0, 0, 0, 0]
            }
          ]
        },
        dymOptionsPD: {
          responsive: false,
          bezierCurve: false,
          elements: {
            line: {
              tension: 0
            }
          },
          maintainAspectRatio: false,
          height: 100,
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItems, data) => {
                // console.log('tooltipItems', tooltipItems, data)
                var val = (tooltipItems.yLabel).toFixed(2)
                val = val.replace('.', ',')
                return val
              })
            }
          },
          scales: {
            yAxes: [{
              type: 'linear',
              position: 'left',
              reverse: true,
              ticks: {
                stepSize: 1,
                min: 1,
                max: 19,
                reverse: true,
                callback: function (value, index, values) {
                  var val = '' + (Math.round(value * 100) / 100).toFixed(2);
                  val = val.replace('.', ',')
                  return val
                }
              }
            }]
          }
        },
        dymOptions: {
          responsive: false, // Vertical Linie ausblenden
          maintainAspectRatio: true,
          bezierCurve: false,
          height: 100,
          elements: {
            line: {
              tension: 0
            }
          },
          tooltips: {
            enabled: true,
            callbacks: null
          },
          scales: {
            yAxes: [{
              type: 'linear',
              position: 'left',
              reverse: true,
              ticks: {
                min: 1,
                max: 19,
                stepSize: 2,
                reverse: true,
                callback: function (value, index, values) {
                  return 'y' + value
                }
              }
            }],
            xAxes: [{
              type: 'linear',
              position: 'left',
              reverse: true,
              ticks: {
                stepSize: 1,
                reverse: true,
                callback: function (value, index, values) {
                  return 'x' + value
                }
              }
            }]
          }
        },
        tableHeightSub: 0,
        fixedHeight: 100,
        missingRight: true
      }
    },
    mounted() {
      this.showMarker = false
      this.myData = null
    }
  }
</script>

<style scoped>
  .small {
    max-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabBilanzrating.vue